/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerGetMigrationPreferencesQueryResponse, TransferCustomersControllerGetMigrationPreferencesPathParams, TransferCustomersControllerGetMigrationPreferences400, TransferCustomersControllerGetMigrationPreferences401, TransferCustomersControllerGetMigrationPreferences403, TransferCustomersControllerGetMigrationPreferences404 } from "../../models/transferCustomersController/TransferCustomersControllerGetMigrationPreferences";

function getTransferCustomersControllerGetMigrationPreferencesUrl(salesforceId: TransferCustomersControllerGetMigrationPreferencesPathParams["salesforceId"]) {
  const res = { method: 'GET', url: `/api/v1/transfer-customers/${salesforceId}/preferences` as const }  
  return res
}

/**
 * @summary Get migration preferences for a customer
 * {@link /api/v1/transfer-customers/:salesforceId/preferences}
 */
export async function transferCustomersControllerGetMigrationPreferences(salesforceId: TransferCustomersControllerGetMigrationPreferencesPathParams["salesforceId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferCustomersControllerGetMigrationPreferencesQueryResponse, ResponseErrorConfig<TransferCustomersControllerGetMigrationPreferences400 | TransferCustomersControllerGetMigrationPreferences401 | TransferCustomersControllerGetMigrationPreferences403 | TransferCustomersControllerGetMigrationPreferences404>, unknown>({ method : "GET", url : getTransferCustomersControllerGetMigrationPreferencesUrl(salesforceId).url.toString(), ... requestConfig })  
  return res.data
}